import { formatQuotaResetsAt } from '../../../utils/isProjectQuotaExceeded';
import { useProjectQuota } from '../../../hooks/useProjectQuota';
import { ProjectQuotaUpgradeLink } from '../../../components/ProjectQuotaUpgradeLink';

/** Always-on weekly project meter pinned in AppSidebar; same shell as SidebarCard, with no dismiss. */
export const ProjectQuotaMeter = ({ isExpanded }) => {
  const quota = useProjectQuota();
  if (!isExpanded || !quota) return null;

  const reset = formatQuotaResetsAt(quota.resets_at);
  const percent = quota.limit > 0 ? Math.min((quota.used / quota.limit) * 100, 100) : 100;

  return (
    <div className='mx-1 mb-3 flex-shrink-0 rounded-xl border border-gray-200 bg-white px-3 py-4'>
      <p className='text-sm text-gray-900'>Weekly resources</p>
      <p className='mt-0.5 text-sm text-gray-600'>
        {quota.used} of {quota.limit} used
      </p>
      <span
        className='mt-2 block h-2 overflow-hidden rounded-full bg-gray-100'
        role='progressbar'
        aria-valuenow={quota.used}
        aria-valuemin={0}
        aria-valuemax={quota.limit}
        aria-label='Weekly resources used'>
        <span
          className='block h-2 rounded-full bg-gray-400 transition-all duration-300'
          style={{ width: `${percent}%` }}
        />
      </span>
      {reset && <p className='mt-2 text-xs text-gray-500'>Resets {reset}</p>}
      <ProjectQuotaUpgradeLink
        location='quota_sidebar_meter'
        quota={quota}
        className='mt-1 text-xs'>
        Upgrade for unlimited ›
      </ProjectQuotaUpgradeLink>
    </div>
  );
};
